import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { propsUtil } from '@asphalt-react/helper';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Loader__17qTu {\n  --loader-background-color-active: var(\n    --interactive-fill-selected-default,\n    hsla(219, 42%, 31%, 1)\n  );\n  --loader-background-color: var(\n    --background-fill-highlight,\n    hsla(220, 22%, 92%, 1)\n  );\n\n  --loader-s-size: 0.5rem;\n  --loader-m-size: 0.75rem;\n  --loader-l-size: 1rem;\n  --loader-animation-duration: 1.1s;\n  --loader-animation-delay: 120ms;\n}\n\n.dot__3brNM {\n  border-radius: 50%;\n  margin-right: 8px;\n  display: inline-block;\n  background-color: var(--loader-background-color);\n}\n\n.dot__3brNM:nth-child(1) {\n  -webkit-animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out infinite;\n          animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out infinite;\n}\n\n.dot__3brNM:nth-child(2) {\n  -webkit-animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 1) infinite;\n          animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 1) infinite;\n}\n\n.dot__3brNM:nth-child(3) {\n  -webkit-animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 2) infinite;\n          animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 2) infinite;\n}\n\n.dot__3brNM:nth-child(4) {\n  -webkit-animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 3) infinite;\n          animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 3) infinite;\n}\n\n.dot__3brNM:nth-child(5) {\n  -webkit-animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 4) infinite;\n          animation: changeColors__n5T4s var(--loader-animation-duration) ease-in-out\n    calc(var(--loader-animation-delay) * 4) infinite;\n}\n\n@-webkit-keyframes changeColors__n5T4s {\n  0%,\n  49% {\n    background-color: var(--loader-background-color-active);\n  }\n  50%,\n  100% {\n    background-color: var(--loader-background-color);\n  }\n}\n\n@keyframes changeColors__n5T4s {\n  0%,\n  49% {\n    background-color: var(--loader-background-color-active);\n  }\n  50%,\n  100% {\n    background-color: var(--loader-background-color);\n  }\n}\n/*\n  If the user has expressed their preference for\n  reduced motion, then reduce animations on loader.\n*/\n@media (prefers-reduced-motion: reduce) {\n  .Loader__17qTu {\n    /* overridden styles here */\n    --loader-animation-duration: 10s;\n    --loader-animation-delay: 1s;\n  }\n}\n\n.s__1eyK- {\n  width: var(--loader-s-size);\n  height: var(--loader-s-size);\n}\n\n.m__3SAcm {\n  width: var(--loader-m-size);\n  height: var(--loader-m-size);\n}\n\n.l__2jOTc {\n  width: var(--loader-l-size);\n  height: var(--loader-l-size);\n}\n\n/* support rtl styles */\n\n*[dir=\"rtl\"] {\n  -webkit-animation-direction: alternate;\n          animation-direction: alternate;\n}\n";
var styles = {"Loader":"Loader__17qTu","dot":"dot__3brNM","changeColors":"changeColors__n5T4s","s":"s__1eyK-","m":"m__3SAcm","l":"l__2jOTc"};
styleInject(css_248z);

/**
 * size values
 */
var sizes = ["s", "m", "l"];
/**
 * loader's dot count value
 */

var count = 5;

var validateSize = propsUtil.validateSize;

var Loader = function Loader(_ref) {
  var size = _ref.size,
      style = _ref.style,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["size", "style", "className"]);

  if (!validateSize(sizes, size)) {
    size = "m";
    console.warn("size should be one of [".concat(sizes, "]. Using fallback size '").concat(size, "'"));
  }

  var dotClass = cn(styles.dot, styles[size]); // set aria-busy to true if it's value is not defined by user

  var isAriaBusy = typeof props["aria-busy"] !== "undefined" ? props["aria-busy"] : true;
  return /*#__PURE__*/React.createElement("span", _extends({
    role: "progressbar",
    className: cn(styles.Loader)
  }, props, {
    "aria-busy": isAriaBusy
  }), _toConsumableArray(Array(count)).map(function (_, i) {
    return /*#__PURE__*/React.createElement("span", {
      key: i,
      className: dotClass
    });
  }));
};
Loader.propTypes = {
  /**
   * Size of the Loader.
   * Accepts s, m and l for small, medium & large respectively
   */
  size: PropTypes.oneOf(["s", "m", "l"])
};
Loader.defaultProps = {
  size: "m"
};

export default Loader;
